<template>
  <v-col>
    <v-row class="mb-8">
      <v-btn
        color="primary"
        @click="CHANGE_RIPARAZIONI_CLIENTI_COMPONENT('Index')"
      >Indietro</v-btn>
    </v-row>
    <v-row>
      <v-card min-width="100%">
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center red--text subtitle-2">Costo ricambi</th>
                  <th class="text-center green--text subtitle-2">Prezzo ricambi</th>
                  <th class="text-center red--text subtitle-2">IVA</th>
                  <th class="text-center green--text subtitle-2">Utile</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="text-center">{{replacementsCost || 0}}€</td>
                  <td class="text-center">{{replacementsPrice || 0}}€</td>
                  <td class="text-center">{{vat || 0}}€</td>
                  <td class="text-center">{{gain || 0}}€</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-row>
    <br>
    <v-row>
      <v-card min-width="100%">
        <v-form
          ref="form"
          v-model="valid"
          :lazy-validation="true"
          autocomplete="off"
        >

          <v-card-text>
            <v-col>
              <v-row>
                <v-col>
                  <h1 class="primary--text">Informazioni Riparazione</h1>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete
                    label="Cerca cliente"
                    v-model="customerModel"
                    :search-input.sync="customerSearch"
                    :items="customers"
                    :loading="isLoading"
                    hide-no-data
                    hide-selected
                    item-text="text"
                    item-value="id"
                    return-object
                    :rules="[rules.required]"
                    required
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  lg="3"
                >
                  <v-text-field
                    label="IMEI"
                    v-model="repair.info.serial"
                    :rules="[rules.required]"
                    required
                  >
                  </v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  lg="3"
                >
                  <v-text-field
                    label="Marchio"
                    v-model="repair.info.brand"
                    :rules="[rules.required]"
                    required
                  >
                  </v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  lg="3"
                >
                  <v-text-field
                    label="Modello"
                    v-model="repair.info.model"
                    :rules="[rules.required]"
                    required
                  >
                  </v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  lg="3"
                >
                  <v-text-field
                    label="Colore"
                    v-model="repair.info.color"
                    :rules="[rules.required]"
                    required
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-textarea
                    label="Nota pubblica"
                    v-model="repair.info.public_note"
                  >
                  </v-textarea>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-textarea
                    label="Nota privata"
                    v-model="repair.info.private_note"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-text>
            <v-col>
              <v-row>
                <v-col>
                  <h1 class="primary--text">Pezzi di Ricambio</h1>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-autocomplete
                    label="Cerca"
                    v-model="replacementModel"
                    :search-input.sync="replacementSearch"
                    :items="filteredReplacements"
                    :loading="isLoading"
                    hide-no-data
                    hide-selected
                    item-text="text"
                    item-value="id"
                    return-object
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  class="pt-8"
                >
                  <v-btn
                    small
                    color="primary"
                    @click="add"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-list>
                    <v-list-item-group color="primary">
                      <v-list-item
                        v-for="(item, index) in repair.replacements"
                        :key="index"
                      >
                        <v-list-item-icon>
                          <v-icon
                            color="red"
                            @click="remove(index)"
                          >mdi-delete</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{item.name}} {{item.model}} {{item.state}} {{item.color || ''}} | {{item.supplier.name}} {{item.cost}}€ -> {{item.price}}€</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >

                  <v-text-field
                    label="Prezzo riparazione"
                    v-model="repair.info.price"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-card-text>

          <v-card-actions>
            <v-col>
              <v-row>
                <v-col>
                  <v-btn
                    :disabled="!valid"
                    color="success"
                    class="mr-4"
                    @click="submit"
                  >
                    Salva riparazione
                  </v-btn>

                  <v-btn
                    color="error"
                    class="mr-4"
                    @click="reset"
                  >
                    Reset Modulo
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-row>
    <snack-notification :snack="snack" />
  </v-col>
</template>

<script>
  import axios from 'axios'
  import { mapMutations } from 'vuex'
  import { accounting } from './../../../mixins/accounting'

  import SnackNotification from './../../SnackNotification'

  export default {
    name: 'Insert',
    components: {
      SnackNotification
    },
    mixins: [accounting],
    data() {
      return {
        repair: {
          info: {
            customer_id: null,
            serial: null,
            brand: null,
            model: null,
            color: null,
            public_note: null,
            private_note: null,
            price: null
          },
          replacements: [],
        },
        search: null,
        customerSearch: null,
        replacementSearch: null,
        customerModel: null,
        replacementModel: null,
        customers: [],
        replacements: [],
        valid: false,
        isLoading: false,
        snack: {
          error: null,
          visible: null,
          message: null
        },
        rules: {
          required: value => !!value || 'Campo obbligatorio.',
        },
        config: {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        },
      }
    },
    methods: {
      ...mapMutations([
        'CHANGE_RIPARAZIONI_CLIENTI_COMPONENT'
      ]),

      async fetchCustomers() {
        const { data } = await axios.get(`${process.env.VUE_APP_API}/v2/customers/fetch`, this.config)

        this.customers = data.map(el => {
          el.text = `${el.name} ${el.surename}`
          return el
        })
      },

      async fetchReplacements() {
        const { data } = await axios.get(`${process.env.VUE_APP_API}/v2/replacements/fetch`, this.config)

        this.replacements = data.map(el => {
          el.text = `${el.amount}x ${el.name} ${el.model} ${el.state} ${el.color || ''} | ${el.supplier.name} ${el.cost}€ -> ${el.price}€`
          return el
        })
      },

      add() {
        if (!this.replacementModel) return

        this.repair.replacements.push(this.replacementModel)

        this.replacements = this.replacements.map(el => {
          if (el.id == this.replacementModel.id) {
            el.amount--
          }

          return el
        })

        this.replacementModel = null
      },

      remove(index) {

        this.replacements = this.replacements.map(el => {
          if (el.id == this.repair.replacements[index].id) {
            el.amount++
          }

          return el
        })


        this.repair.replacements.splice(index, 1)

      },

      async submit() {

        if (this.$refs.form.validate() && (this.repair.replacements.length > 0)) {

          this.snack = Object.assign({}, {
            error: null,
            visible: null,
            message: null
          })

          const { data } = await axios.post(`${process.env.VUE_APP_API}/v2/repairs/customer/create`, this.repair, this.config)

          if (data.status) {

            this.snack = Object.assign({}, {
              visible: true,
              error: false,
              message: 'Riparazione salvata correttamente!'
            })

            this.reset()
          } else {

            this.snack = Object.assign({}, {
              visible: true,
              error: true,
              message: 'Errore nel salvataggio.'
            })
          }

        }
      },

      reset() {
        this.$refs.form.reset()
        this.repair = {
          info: {
            customer_id: null,
            serial: null,
            brand: null,
            model: null,
            color: null,
            public_note: null,
            private_note: null,
            price: null
          },
          replacements: []
        }
        this.customerModel = null
      },
    },

    computed: {
      filteredReplacements() {
        return this.replacements.filter(el => el.amount > 0)
      },

      replacementsCost() {
        if (this.repair.replacements.length < 1) return

        return this.repair.replacements.map((el) => {
          return el.cost
        }).reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))
      },

      replacementsPrice() {
        if (this.repair.replacements.length < 1) return

        const price = this.repair.replacements.map((el) => {
          return el.price
        }).reduce((accumulator, currentValue) => parseFloat(accumulator) + parseFloat(currentValue))

        this.repair.info.price = price

        return price
      },

      vat() {
        const price = parseFloat(this.repair.info.price || 0)

        if (price <= 0) return

        const res = this._calculateVat(0.00, price, false).toFixed(2)

        return res > 0 ? res : "0"
      },

      gain() {
        const price = parseFloat(this.repair.info.price || 0).toFixed(2)
        const cost = parseFloat(0).toFixed(2)
        const extra = (parseFloat(this.replacementsCost || 0) + parseFloat(this.accessoriesCost || 0)).toFixed(2)
        const vat = parseFloat(this.vat || 0).toFixed(2)

        if (!this.vat || !price) return

        return parseFloat(price - vat - cost - extra).toFixed(2)
      }
    },

    watch: {
      customerModel(val) {
        if (val) {
          this.repair.info.customer_id = val.id
        } else {
          this.repair.info.customer_id = null
        }
      }
    },

    async mounted() {
      await this.fetchCustomers()
      await this.fetchReplacements()
    }
  }
</script>